import React from 'react';
import { Box } from '@clariness/clarikit-react';

type AccountPageLayoutFormProps = React.PropsWithChildren<{
  onSubmit: () => void;
}>;

export const AccountPageLayoutForm: React.FC<AccountPageLayoutFormProps> = ({
  children,
  onSubmit,
}) => {
  return (
    <Box
      as="form"
      role="form"
      display="flex"
      flexDirection="column"
      gap="34px"
      width="100%"
      style={{ marginTop: '34px' }}
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      {children}
    </Box>
  );
};
